<template>
	<page>
		<module>
			<settle-list></settle-list>
			<settled-list></settled-list>
		</module>
	</page>
</template>

<script>
	import settleList from './settle_record.vue'
	import settledList from './settled_record.vue'
	
	export default {
		components: {
      settleList,
      settledList
		}
	}
</script>

<style lang="stylus" scoped>
  >>> .sku {
    box-sizing: border-box;
    padding: 10px 0 10px 14px;

    &-image {
      width: 80px;
      height: 80px;
      margin-right: 24px;
    }

    &-name {
      font-size: 12px;
      color: #666;
    }

    &-spec {
      margin-top: 10px;
      font-size: 12px;
    }
  }
</style>
